// A private bookmark, never linked by the public interface. Authorization lives on the API.
const configuredPath = process.env.REACT_APP_ADMIN_PATH?.trim();
export const ADMIN_PATH = /^\/[a-zA-Z0-9_-]{12,}$/.test(configuredPath || '')
    ? configuredPath : '/gestione-7d93b2e6a8c14f05';
export const ADMIN_API = `${(process.env.REACT_APP_AUTH_API_URL || '').replace(/\/+$/, '')}/admin`;
